import React from 'react';

/**
 * Başvuru dönemi bilgilendirme bandı.
 * isOpen: true (açık) | false (kapalı) | null (sunucudan bilgi alınamadı)
 */
const PeriodBanner = ({ periodText, isOpen }) => {
  const closed = isOpen === false;

  return (
    <div
      className={`flex items-start gap-3 p-4 rounded-xl border-2 mb-6 ${closed
        ? 'bg-red-50 border-red-200'
        : 'bg-primary-light border-primary/20'
        }`}
    >
      <svg
        className={`w-5 h-5 flex-shrink-0 mt-0.5 ${closed ? 'text-red-500' : 'text-primary'}`}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
      <div className={`text-sm leading-relaxed ${closed ? 'text-red-800' : 'text-primary-text'}`}>
        <span className="font-bold">Başvuru Tarihleri: </span>
        <span className="font-semibold">{periodText}</span>
        {closed && (
          <p className="mt-1 font-medium">
            Şu anda başvuru dönemi dışındasınız; yeni başvuru alınamamaktadır.
            Mevcut başvurunuzun durumunu “Başvuru Sorgula” sekmesinden görüntüleyebilirsiniz.
          </p>
        )}
      </div>
    </div>
  );
};

export default PeriodBanner;
